import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "../images/Rubia Jewels Logo[1]  png.png"
import { Link } from "react-router-dom";

const Navbar = () => {
  const [wishlistCount, setWishlistCount] = useState(0);
  const firstName = localStorage.getItem("firstName");

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");
    if (confirmLogout) {
      localStorage.removeItem("token");
      localStorage.removeItem("firstName");
      alert("You have been logged out!");
      window.location.href = "/login";
    }
  };

  useEffect(() => {
    const storedWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    setWishlistCount(storedWishlist.length);
  }, []);

  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const isCurrentlyMobile = window.innerWidth <= 768;
      setIsMobile(isCurrentlyMobile);

      if (!isCurrentlyMobile) {
        setIsBurgerMenuOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const toggleDropdown = (dropdown) => {
    if (isMobile) {
      setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button
          className="burger-menu"
          onClick={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}
        >
          ☰
        </button>

        <Link to="/" className="navbar-logo">
          {/* <h2>RUBIA</h2> */}
          <img src={logo} />
        </Link>

        <div className="navbar-left">
          <div
            className="dropdown"
            onClick={() => toggleDropdown("trending")}
            onMouseEnter={() => !isMobile && setActiveDropdown("trending")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Trending</button>
            {(isMobile ? activeDropdown === "trending" : true) && (
              <div className="dropdown-menu">
                <Link to="/trending" className="dropdown-item">
                  All Trending
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("earrings")}
            onMouseEnter={() => !isMobile && setActiveDropdown("earrings")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Earrings</button>
            {(isMobile ? activeDropdown === "Earrings" : true) && (
              <div className="dropdown-menu">
                <Link to="/earrings" className="dropdown-item">
                  All Earrings
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("rings")}
            onMouseEnter={() => !isMobile && setActiveDropdown("rings")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Rings</button>
            {(isMobile ? activeDropdown === "rings" : true) && (
              <div className="dropdown-menu">
                <Link to="/ring" className="dropdown-item">
                  All Rings
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("necklaces")}
            onMouseEnter={() => !isMobile && setActiveDropdown("necklaces")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Necklaces</button>
            {(isMobile ? activeDropdown === "necklaces" : true) && (
              <div className="dropdown-menu">
                <Link to="/necklaces" className="dropdown-item">
                  All Necklaces
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("bracelets")}
            onMouseEnter={() => !isMobile && setActiveDropdown("bracelets")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Bracelets</button>
            {(isMobile ? activeDropdown === "bracelets" : true) && (
              <div className="dropdown-menu">
                <Link to="/bracelets" className="dropdown-item">
                  All Bracelets
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("Gifts")}
            onMouseEnter={() => !isMobile && setActiveDropdown("Gifts")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Gifts</button>
            {(isMobile ? activeDropdown === "Gifts" : true) && (
              <div className="dropdown-menu">
                <Link to="/gifts" className="dropdown-item">
                  All Gifts
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="navbar-right">
          {firstName ? (
            <div className="login-buttons">
              <button className="logout-button" onClick={handleLogout} style={{ marginLeft: "10px" }}>
                <i class="fa-solid fa-right-from-bracket"></i>
              </button>
            </div>
          ) : (
            <Link to="/login" className="nav-icon">
              <i class="fa-solid fa-user"></i>
            </Link>
          )}

          <Link to="/wishlist" className="nav-icon">
            <i className="fa-regular fa-heart"></i>
          </Link>
          <Link to="/cart" className="nav-icon">
            <i class="fa-solid fa-cart-shopping"></i>
          </Link>
        </div>
      </div>

      {isBurgerMenuOpen && (
        <div className="burger-menu-content">
          <div
            className="dropdown"
            onClick={() => toggleDropdown("trending")}
            onMouseEnter={() => !isMobile && setActiveDropdown("trending")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Trending</button>
            {(isMobile ? activeDropdown === "trending" : true) && (
              <div className="dropdown-menu">
                <Link to="/trending" className="dropdown-item">
                  All Trending
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("earrings")}
            onMouseEnter={() => !isMobile && setActiveDropdown("earrings")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Earrings</button>
            {(isMobile ? activeDropdown === "earrings" : true) && (
              <div className="dropdown-menu">
                <Link to="/earrings" className="dropdown-item">
                  All Earrings
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("rings")}
            onMouseEnter={() => !isMobile && setActiveDropdown("rings")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Rings</button>
            {(isMobile ? activeDropdown === "rings" : true) && (
              <div className="dropdown-menu">
                <Link to="/ring" className="dropdown-item">
                  All Rings
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("necklaces")}
            onMouseEnter={() => !isMobile && setActiveDropdown("necklaces")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Necklaces</button>
            {(isMobile ? activeDropdown === "necklaces" : true) && (
              <div className="dropdown-menu">
                <Link to="/necklaces" className="dropdown-item">
                  All Necklaces
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("bracelets")}
            onMouseEnter={() => !isMobile && setActiveDropdown("bracelets")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Bracelets</button>
            {(isMobile ? activeDropdown === "bracelets" : true) && (
              <div className="dropdown-menu">
                <Link to="/bracelets" className="dropdown-item">
                  All Bracelets
                </Link>
              </div>
            )}
          </div>

          <div
            className="dropdown"
            onClick={() => toggleDropdown("Gifts")}
            onMouseEnter={() => !isMobile && setActiveDropdown("Gifts")}
            onMouseLeave={() => !isMobile && setActiveDropdown(null)}
          >
            <button className="dropdown-toggle">Gifts</button>
            {(isMobile ? activeDropdown === "Gifts" : true) && (
              <div className="dropdown-menu">
                <Link to="/gifts" className="dropdown-item">
                  All Gifts
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
